import { Controller } from "@hotwired/stimulus"

// The narrated workflow's at-a-glance line (paperwork_events/_storyline): when
// it is longer than its column it opens scrolled to its newest end, where the
// workflow stands now, and marks the side that has more with a soft fade.
export default class extends Controller {
  connect() {
    this.onScroll = () => this.mark()
    this.element.addEventListener("scroll", this.onScroll, { passive: true })
    this.toEnd()
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.onScroll)
  }

  // A live redraw morphs the line in place; keep the newest step in sight.
  toEnd() {
    this.element.scrollLeft = this.element.scrollWidth
    this.mark()
  }

  mark() {
    const { scrollLeft, scrollWidth, clientWidth } = this.element
    this.element.toggleAttribute("data-more-before", scrollLeft > 1)
    this.element.toggleAttribute("data-more-after", scrollLeft + clientWidth < scrollWidth - 1)
  }
}
